.practiceplaceName {
  display: flex;
  align-items: center;
  margin: auto;

  span:first-child {
    margin-right: 0.33em;
  }
}
